import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { WebActivityLinkedServiceAdapter } from './web-activity-linkedservice.adapter';
import { FabricDataPipelinesLinkedService } from 'app/model/linkedservice/fabric-data-pipelines.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricDataPipelinesLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                authentication: '*',
                baseUrl: '*',
                username: '*',
                resource: '*',
                userTenant: '*',
                password: 'secret',
                pfx: 'secret',
                credential: '*',
                enableServerCertificateValidation: '*'
            },
            parameters: '*'
        }
    }
})
export class FabricDataPipelinesLinkedServiceAdapter extends WebActivityLinkedServiceAdapter {
    protected modelConstructor(): new () => FabricDataPipelinesLinkedService {
        return FabricDataPipelinesLinkedService;
    }

    protected model(): IModel {
        return FabricDataPipelinesLinkedService.MODEL;
    }
}
